(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import HsCodesTreeContainer from "../../containers/HsCodesTreeContainer";
import HsCodesTree from "../../../../components/HsCodesTree";
import Loading from "../../../../components/Loading";
import styles from "./HsCodeDetailsTree.module.css";

const HsCodeDetailsTree = _ref => {
  var _hsCode2Details$child;

  let {
    hsCode2Details,
    chapter,
    searchCode,
    colors,
    isLoading,
    isRtl
  } = _ref;
  const {
    t
  } = useTranslation();
  const hasError = useMemo(() => hsCode2Details && hsCode2Details.hasError, [hsCode2Details]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.tree
  }, isLoading ? /*#__PURE__*/React.createElement("div", {
    className: styles.center
  }, /*#__PURE__*/React.createElement(Loading, {
    color: colors.success
  })) : hasError ? /*#__PURE__*/React.createElement("div", {
    className: styles.center
  }, t("The chapter {{chapter}} does not exist.", {
    chapter
  }), t("Please press the previous/next arrows to change the chapter or run another search using the bar above.")) : /*#__PURE__*/React.createElement(HsCodesTree, {
    code: hsCode2Details.code,
    description: hsCode2Details.description,
    searchCode: searchCode,
    colors: colors,
    collapsable: true,
    bold: true,
    isRtl: isRtl
  }, hsCode2Details === null || hsCode2Details === void 0 ? void 0 : (_hsCode2Details$child = hsCode2Details.children) === null || _hsCode2Details$child === void 0 ? void 0 : _hsCode2Details$child.map(child => /*#__PURE__*/React.createElement(HsCodesTree.Child, {
    isRtl: isRtl,
    key: "".concat(child.code, "-").concat(child.description)
  }, /*#__PURE__*/React.createElement(HsCodesTreeContainer, {
    code: child.code,
    description: child.description,
    searchCode: searchCode,
    collapsable: true,
    isLoading: true
  })))));
};

__signature__(HsCodeDetailsTree, "useTranslation{{ t }}\nuseMemo{hasError}", () => [useTranslation]);

HsCodeDetailsTree.defaultProps = {
  hsCode2Details: null,
  isRtl: false
};
HsCodeDetailsTree.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  chapter: PropTypes.string.isRequired,
  hsCode2Details: PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string,
    children: PropTypes.array,
    hasError: PropTypes.bool
  }),
  searchCode: PropTypes.string.isRequired,
  colors: PropTypes.shape({
    info: PropTypes.string,
    success: PropTypes.string,
    secondary: PropTypes.string
  }).isRequired,
  isRtl: PropTypes.bool
};

const _default = /*#__PURE__*/React.memo(HsCodeDetailsTree);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(HsCodeDetailsTree, "HsCodeDetailsTree", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/HsCodeDetailsTree/HsCodeDetailsTree.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/HsCodeDetailsTree/HsCodeDetailsTree.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();